import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "order",
    prepareHeaders: (headers, { getState }) => {
      const token =
        getState()?.userSlice?.token || localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),

  endpoints: (builder) => ({
    //         createAgreement: builder.mutation({
    //             query:({ ...body })=>{
    //                 const payload = { ...body };
    //              return {
    //           url: "/",
    //           method: "POST",
    //           body: payload,
    //         };
    //       },
    //       invalidatesTags: ["Agreement"],
    //         }),

    getOrder: builder.query({
      query: () => ({
        url: ``,
        method: "GET",
      }),
    }),
    getOneOrder: builder.query({
      query: ({ id }) => ({
        url: `${id}`,
        method: "GET",
      }),
    }),
    OrderStart: builder.mutation({
      query: ({ id }) => ({
        url: `/${id}/start`,
        method: "PATCH",
      }),
    }),
    OrderEnd: builder.mutation({
      query: ({ id }) => ({
        url: `/${id}/work-done`,
        method: "PATCH",
      }),
    }),
    OrderCustomerEnd: builder.mutation({
      query: ({ id }) => ({
        url: `/${id}/confirm`,
        method: "PATCH",
      }),
    }),
    OrderRaise: builder.mutation({
      query: ({ orderId, newPrice, newDurationDays, reason }) => ({
        url: `/${orderId}/revision/request`,
        method: "PATCH",
        body: {
          newPrice,
          newDurationDays,
          reason,
        },
      }),
    }),

    OrderRaiseAccept: builder.mutation({
      query: ({ id }) => ({
        url: `/${id}/revision/approve`,
        method: "PATCH",
      }),
    }),
    OrderRaiseReject: builder.mutation({
      query: ({ id }) => ({
        url: `/${id}/revision/reject`,
        method: "PATCH",
      }),
    }),
  }),
});

export const {
  useGetOrderQuery,
  useOrderStartMutation,
  useOrderEndMutation,
  useOrderCustomerEndMutation,
  useOrderRaiseMutation,
  useOrderRaiseAcceptMutation,
  useOrderRaiseRejectMutation,
  useGetOneOrderQuery
} = orderApi;
